import React, { useState } from "react";
import { Box, Typography, Grid, TextField, Button, Paper } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ModalPrice from "./modalPrice";
import AddressSearch from "./AddressSearch";

const requiredLabelProps = {
  required: true,
  sx: { "& .MuiFormLabel-asterisk": { color: "red" } },
};

export default function StepMetodoSalida({
  tipo,
  datos,
  setDatos,
  onNext,
  onBack,
  product_ids,
  packages = [],
}) {
  const [innerStep, setInnerStep] = useState(1);

  const handleChange = (section, e) => {
    const { name, value } = e.target;
    setDatos((prev) => ({
      ...prev,
      [section]: { ...prev[section], [name]: value },
    }));
  };

  // Selección del buscador inteligente (Nominatim/AR). En modo "postal" solo completa
  // Localidad/Provincia/CP (la calle y el nro los tipea el operador); en modo "address"
  // completa además Calle y Nro. Nunca pisa un campo con vacío.
  const handleAddressSelect = (sel) => {
    if (!sel) return;
    setDatos((prev) => ({
      ...prev,
      cliente: {
        ...prev.cliente,
        localidad: sel.city || prev.cliente.localidad,
        provincia: sel.province || prev.cliente.provincia,
        cp: sel.postcode || prev.cliente.cp,
        ...(sel.mode === "address"
          ? {
              direccion: sel.street || prev.cliente.direccion,
              altura: sel.streetNumber || prev.cliente.altura,
            }
          : {}),
      },
    }));
  };

  const handleNextInternal = () => {
    if ((tipo === "redespacho" || tipo === "red_despacho") && innerStep === 1) {
      setInnerStep(2);
    } else {
      onNext();
    }
  };

  const handleBackInternal = () => {
    if (innerStep === 2) {
      setInnerStep(1);
    } else {
      onBack();
    }
  };

  const v = (x) => (x ?? "").toString().trim();
  const canContinueDestinatario =
    v(datos.cliente.nombre) &&
    v(datos.cliente.id) &&
    v(datos.cliente.telefono) &&
    v(datos.cliente.email);
  const canContinueUbicacion =
    v(datos.cliente.direccion) &&
    v(datos.cliente.altura) &&
    v(datos.cliente.cp) &&
    v(datos.cliente.localidad);
  const canContinueStep1Cliente = canContinueDestinatario;
  const canContinueStep1Redespacho =
    canContinueDestinatario && canContinueUbicacion;
  // Transporte retira (sin integración): destinatario + ubicación + nombre del transporte.
  const canContinueTransporteManual =
    canContinueDestinatario && canContinueUbicacion && v(datos.transportes.t1_empresa);
  const canContinueTransportes =
    v(datos.transportes.t1_empresa) &&
    v(datos.transportes.t2_empresa);

  if (innerStep === 1) {
    return (
      <Box>
        <Typography variant="h6" mb={3} fontWeight="bold" textAlign={"start"}>
          {tipo === "cliente"
            ? "Datos de Retiro"
            : "Datos del Destinatario y Destino"}
        </Typography>

        <Grid container spacing={3}>
          {/* COLUMNA 1: DESTINATARIO */}
          <Grid item xs={12} sm={tipo === "cliente" ? 12 : 6}>
            <Typography
              variant="subtitle2"
              color="primary"
              mb={3}
              textAlign={"start"}
            >
              DESTINATARIO
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={tipo === "cliente" ? 6 : 12}>
                <TextField
                  fullWidth
                  label="Nombre y Apellido / Razón Social"
                  name="nombre"
                  value={datos.cliente.nombre}
                  onChange={(e) => handleChange("cliente", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="DNI / CUIT"
                  name="id"
                  value={datos.cliente.id}
                  onChange={(e) => handleChange("cliente", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Teléfono"
                  name="telefono"
                  value={datos.cliente.telefono}
                  onChange={(e) => handleChange("cliente", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
              <Grid item xs={tipo === "cliente" ? 6 : 12}>
                <TextField
                  fullWidth
                  label="Email"
                  name="email"
                  value={datos.cliente.email}
                  onChange={(e) => handleChange("cliente", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
            </Grid>
          </Grid>

          {tipo !== "cliente" && (
            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                color="primary"
                mb={3}
                textAlign={"start"}
              >
                UBICACIÓN DE ENTREGA
              </Typography>
              <Box mb={2}>
                <AddressSearch onSelect={handleAddressSelect} />
              </Box>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <TextField
                    fullWidth
                    label="Calle"
                    name="direccion"
                    value={datos.cliente.direccion}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                    required
                    InputLabelProps={requiredLabelProps}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                    fullWidth
                    label="Nro"
                    name="altura"
                    value={datos.cliente.altura || ""}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                    required
                    InputLabelProps={requiredLabelProps}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="P y dpto"
                    name="piso_dpto"
                    value={datos.cliente.piso_dpto || ""}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="CP"
                    name="cp"
                    value={datos.cliente.cp || ""}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                    required
                    InputLabelProps={requiredLabelProps}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Localidad"
                    name="localidad"
                    value={datos.cliente.localidad}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                    required
                    InputLabelProps={requiredLabelProps}
                  />
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    fullWidth
                    label="Provincia"
                    name="provincia"
                    value={datos.cliente.provincia || ""}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Referencia"
                    name="referencia"
                    value={datos.cliente.referencia || ""}
                    onChange={(e) => handleChange("cliente", e)}
                    size="small"
                  />
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>

        {tipo === "transporte_manual" && (
          <Box mt={4}>
            <Typography variant="subtitle2" color="primary" mb={2} textAlign={"start"}>
              TRANSPORTE
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField
                  fullWidth
                  label="Nombre del transporte"
                  name="t1_empresa"
                  value={datos.transportes.t1_empresa}
                  onChange={(e) => handleChange("transportes", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
            </Grid>
          </Box>
        )}

        <Box mt={5} display="flex" justifyContent="space-between">
          <Button
            variant="outlined"
            onClick={handleBackInternal}
            startIcon={<ArrowBackIcon />}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
              borderColor: "#cbd5e1",
              color: "#475569",
              "&:hover": { borderColor: "#94a3b8", backgroundColor: "#f8fafc" },
            }}
          >
            Volver
          </Button>
          <Button
            variant="contained"
            onClick={handleNextInternal}
            disabled={
              tipo === "cliente"
                ? !canContinueStep1Cliente
                : tipo === "transporte_manual"
                  ? !canContinueTransporteManual
                  : !canContinueStep1Redespacho
            }
            endIcon={<ArrowForwardIcon />}
            sx={{
              borderRadius: "8px",
              textTransform: "none",
              fontWeight: 600,
              px: 3,
            }}
          >
            Siguiente
          </Button>
        </Box>
      </Box>
    );
  }

  if (tipo === "red_despacho") {
    return (
      <ModalPrice
        product_ids={product_ids}
        packages={packages}
        onClose={handleBackInternal}
        datosCliente={datos.cliente}
        onConfirm={(seleccion) => {
          setDatos((prev) => ({ ...prev, cotizacionSeleccionada: seleccion }));
          onNext();
        }}
      />
    );
  }

  return (
    <Box>
      <Typography variant="h6" mb={3} fontWeight="bold" textAlign={"start"}>
        Información de Transportes
      </Typography>

      <Grid container spacing={3}>
        {/* Transporte 1 */}
        <Grid item xs={12} sm={6}>
          <Paper
            variant="outlined"
            sx={{ p: 3, borderTop: "4px solid orange" }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              T1 - Transporte Intermedio
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Transporte que retira de nuestro depósito
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Empresa / Chofer"
                  name="t1_empresa"
                  value={datos.transportes.t1_empresa}
                  onChange={(e) => handleChange("transportes", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Teléfono (opcional)"
                  name="t1_telefono"
                  value={datos.transportes.t1_telefono || ""}
                  onChange={(e) => handleChange("transportes", e)}
                  size="small"
                />
              </Grid>
              <Grid item xs={6}>
                <TextField
                  fullWidth
                  label="Patente (opcional)"
                  name="t1_patente"
                  value={datos.transportes.t1_patente}
                  onChange={(e) => handleChange("transportes", e)}
                  size="small"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>

        {/* Transporte 2 */}
        <Grid item xs={12} sm={6}>
          <Paper
            variant="outlined"
            sx={{ p: 3, borderTop: "4px solid #2563EB" }}
          >
            <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
              T2 - Transporte Final
            </Typography>
            <Typography variant="body2" color="text.secondary" mb={2}>
              Transporte que entrega al cliente final
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Empresa / Chofer"
                  name="t2_empresa"
                  value={datos.transportes.t2_empresa}
                  onChange={(e) => handleChange("transportes", e)}
                  size="small"
                  required
                  InputLabelProps={requiredLabelProps}
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </Grid>

      <Box mt={5} display="flex" justifyContent="space-between">
        <Button
          variant="outlined"
          onClick={handleBackInternal}
          startIcon={<ArrowBackIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
            borderColor: "#cbd5e1",
            color: "#475569",
            "&:hover": { borderColor: "#94a3b8", backgroundColor: "#f8fafc" },
          }}
        >
          Volver
        </Button>
        <Button
          variant="contained"
          onClick={handleNextInternal}
          disabled={!canContinueTransportes}
          endIcon={<ArrowForwardIcon />}
          sx={{
            borderRadius: "8px",
            textTransform: "none",
            fontWeight: 600,
            px: 3,
          }}
        >
          Siguiente
        </Button>
      </Box>
    </Box>
  );
}
